import React from "react";
import { Modal, Button } from "react-bootstrap";
import "../../styles/CustomModal.css";

const CustomModal = ({
  show,
  onHide,
  onConfirm,
  width,
  height,
  message = "메시지 없음",
  confirmText = "확인",
  cancelText = "취소",
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body
        style={{
          width: `${width}px`,
          height: `${height}px`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <p
          style={{
            fontSize: "18px",
            marginBottom: "30px",
            whiteSpace: "pre-line",
          }}
        >
          {message}
        </p>
        <div className="custom-modal-buttons">
          {cancelText && cancelText.trim() !== "" && (
            <Button
              variant="secondary"
              className="custom-modal-btn"
              onClick={onHide}
            >
              {cancelText}
            </Button>
          )}
          <Button
            variant="primary"
            className="custom-modal-btn"
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;
